import { getSharedI18nInstance } from "@bitsentry-ce/i18n";

import enUSACommon from "./locales/en-US/common.json";
import enUSAIncidents from "./locales/en-US/incidents.json";
import enUSANavigation from "./locales/en-US/navigation.json";
import enUSAErrors from "./locales/en-US/errors.json";
import enGBCommon from "./locales/en-GB/common.json";
import enGBIncidents from "./locales/en-GB/incidents.json";
import enGBNavigation from "./locales/en-GB/navigation.json";
import enGBErrors from "./locales/en-GB/errors.json";
import enAUCommon from "./locales/en-AU/common.json";
import enAUIncidents from "./locales/en-AU/incidents.json";
import enAUNavigation from "./locales/en-AU/navigation.json";
import enAUErrors from "./locales/en-AU/errors.json";
import frCommon from "./locales/fr-FR/common.json";
import frIncidents from "./locales/fr-FR/incidents.json";
import frNavigation from "./locales/fr-FR/navigation.json";
import frErrors from "./locales/fr-FR/errors.json";
import zhCommon from "./locales/zh-CN/common.json";
import zhIncidents from "./locales/zh-CN/incidents.json";
import zhNavigation from "./locales/zh-CN/navigation.json";
import zhErrors from "./locales/zh-CN/errors.json";
import idCommon from "./locales/id-ID/common.json";
import idIncidents from "./locales/id-ID/incidents.json";
import idNavigation from "./locales/id-ID/navigation.json";
import idErrors from "./locales/id-ID/errors.json";

const resources = {
  "en-US": {
    common: enUSACommon,
    incidents: enUSAIncidents,
    navigation: enUSANavigation,
    errors: enUSAErrors,
  },
  "en-GB": {
    common: enGBCommon,
    incidents: enGBIncidents,
    navigation: enGBNavigation,
    errors: enGBErrors,
  },
  "en-AU": {
    common: enAUCommon,
    incidents: enAUIncidents,
    navigation: enAUNavigation,
    errors: enAUErrors,
  },
  "fr-FR": {
    common: frCommon,
    incidents: frIncidents,
    navigation: frNavigation,
    errors: frErrors,
  },
  "zh-CN": {
    common: zhCommon,
    incidents: zhIncidents,
    navigation: zhNavigation,
    errors: zhErrors,
  },
  "id-ID": {
    common: idCommon,
    incidents: idIncidents,
    navigation: idNavigation,
    errors: idErrors,
  },
} as const;

type SharedI18nInstance = ReturnType<typeof getSharedI18nInstance>;

let registeredInstance: SharedI18nInstance | null = null;

export function registerTicketResolutionTranslations(): void {
  const i18n = getSharedI18nInstance();
  if (registeredInstance === i18n) return;

  const registerResources = () => {
    for (const [locale, namespaces] of Object.entries(resources)) {
      for (const [namespace, bundle] of Object.entries(namespaces)) {
        i18n.addResourceBundle(locale, namespace, bundle, true, true);
      }
    }
  };

  registerResources();
  i18n.on("initialized", registerResources);
  i18n.on("languageChanged", registerResources);
  registeredInstance = i18n;
}
